var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-header-wrapper",
    [
      _c(
        "a-card",
        [
          _vm.$access("ENT_DIVISION_RECEIVER_GROUP_LIST")
            ? _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      staticClass: "table-head-ground",
                      attrs: { layout: "inline" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "table-layer" },
                        [
                          _c("jeepay-text-up", {
                            attrs: {
                              placeholder: "组ID",
                              msg: _vm.searchData.receiverGroupId,
                            },
                            model: {
                              value: _vm.searchData.receiverGroupId,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchData, "receiverGroupId", $$v)
                              },
                              expression: "searchData.receiverGroupId",
                            },
                          }),
                          _c("jeepay-text-up", {
                            attrs: {
                              placeholder: "组名称",
                              msg: _vm.searchData.receiverGroupName,
                            },
                            model: {
                              value: _vm.searchData.receiverGroupName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchData,
                                  "receiverGroupName",
                                  $$v
                                )
                              },
                              expression: "searchData.receiverGroupName",
                            },
                          }),
                          _c(
                            "span",
                            { staticClass: "table-page-search-submitButtons" },
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "search",
                                    loading: _vm.btnLoading,
                                  },
                                  on: { click: _vm.searchFunc },
                                },
                                [_vm._v("查询")]
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  attrs: { icon: "reload" },
                                  on: { click: () => (this.searchData = {}) },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    [
                      _vm.$access("ENT_DIVISION_RECEIVER_GROUP_ADD")
                        ? _c(
                            "a-button",
                            {
                              staticClass: "mg-b-30",
                              attrs: { type: "primary", icon: "plus" },
                              on: { click: _vm.addFunc },
                            },
                            [_vm._v("新建")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("JeepayTable", {
            ref: "infoTable",
            attrs: {
              initData: true,
              reqTableDataFunc: _vm.reqTableDataFunc,
              tableColumns: _vm.tableColumns,
              searchData: _vm.searchData,
              rowKey: "receiverGroupId",
            },
            on: {
              btnLoadClose: function ($event) {
                _vm.btnLoading = false
              },
            },
            scopedSlots: _vm._u([
              {
                key: "opSlot",
                fn: function ({ record }) {
                  return [
                    _c("JeepayTableColumns", [
                      _vm.$access("ENT_DIVISION_RECEIVER_GROUP_EDIT")
                        ? _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.editFunc(record.receiverGroupId)
                                },
                              },
                            },
                            [_vm._v("修改")]
                          )
                        : _vm._e(),
                      _vm.$access("ENT_DIVISION_RECEIVER_GROUP_DELETE")
                        ? _c(
                            "a",
                            {
                              staticStyle: { color: "red" },
                              on: {
                                click: function ($event) {
                                  return _vm.delFunc(record.receiverGroupId)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("InfoAddOrEdit", {
        ref: "infoAddOrEdit",
        attrs: { callbackFunc: _vm.searchFunc },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }